import { apiClient } from "@/shared/api/client"
import { uploadFileToS3 } from "@/shared/api/upload-to-s3"
export type TaxonomyKind = "formats" | "topics" | "niches" | "durations"
export interface TaxonomyItem {
	id: string
	name: string
	iconUrl?: string | null
	/** Сколько материалов отмечено этим значением. */
	postCount?: number
}
export const listTaxonomy = async (kind: TaxonomyKind): Promise<TaxonomyItem[]> =>
	(await apiClient.get(`/${kind}`)).data
export const setTaxonomyIcon = async (
	kind: TaxonomyKind,
	id: string,
	iconUrl: string | null,
): Promise<TaxonomyItem> => (await apiClient.put(`/${kind}/${id}`, { iconUrl })).data
export async function uploadTaxonomyIcon(kind: TaxonomyKind, item: TaxonomyItem, file: File) {
	if (
		!["image/jpeg", "image/png", "image/webp", "image/svg+xml"].includes(file.type) ||
		file.size > 1024 * 1024 ||
		!file.size
	)
		throw new Error("Выберите JPEG, PNG, WebP или SVG размером до 1 МБ")
	const { data } = await apiClient.post<{ url: string; iconUrl: string }>(
		"/admin/taxonomy-icons/presign",
		{ kind, filename: file.name, mimeType: file.type, size: file.size },
	)
	await uploadFileToS3(data.url, file)
	return setTaxonomyIcon(kind, item.id, data.iconUrl)
}

export const createTaxonomy = async (kind: TaxonomyKind, name: string): Promise<TaxonomyItem> =>
	(await apiClient.post(`/${kind}`, { name })).data
export const renameTaxonomy = async (
	kind: TaxonomyKind,
	id: string,
	name: string,
): Promise<TaxonomyItem> => (await apiClient.put(`/${kind}/${id}`, { name })).data
export const deleteTaxonomy = async (kind: TaxonomyKind, id: string): Promise<void> => {
	await apiClient.delete(`/${kind}/${id}`)
}
